<template>
    <div class="heavy-currency invest-currency">
        <div class="currency-top-bk">
            <div>
                <VillagesTopNav imgSrc="white" :borderShow="false"
                    :options="{navColor:'#fff',bgColor:'transparent',borderWidth:'0px'}"
                    @leftIconFun="()=>{this.$router.go(-1);}">
                    <h2 slot="content">充值重消币</h2>
                </VillagesTopNav>
                <div class="chong-zhi">
                    <p class="currency-font">1元=10个重消币</p>
                    <div class="invest-input">
                        <!-- <span class="symbol">¥</span> -->
                        <van-field v-model="value" clearable type="digit" placeholder="请输入充值数量" />
                    </div>
                </div>
            </div>
        </div>
        <div class="pay-type">
            选择支付方式：
        </div>
        <div class="pay-list">

            <van-radio-group v-model="radio">
                <van-cell-group>
                    <van-cell title="微信支付" clickable @click="radio = '1'">
                        <template #icon>
                            <img class="pay-left-icon" src="../../assets/img/icon/weixinzhifu.png" alt="" srcset="">
                        </template>
                        <template #right-icon>
                            <van-radio name="1" />
                        </template>
                    </van-cell>
                    <!-- <van-cell title="支付宝支付" clickable @click="radio = '2'">
                        <template #icon>
                            <img class="pay-left-icon" src="../../assets/img/icon/zhifubao.png" alt="" srcset="">
                        </template>
                        <template #right-icon>
                            <van-radio name="2" />
                        </template>
                    </van-cell> -->
                </van-cell-group>
            </van-radio-group>
        </div>
        <div class="pay-currency-btn" @click="payClick">
            充值
        </div>
        <van-dialog v-model="show" confirmButtonColor='#F2190B' class="cgdialog">
            <div class="chenggong">
                <img src="../../assets/img/chenggong.png" alt="">
                <P>充值成功</P>
            </div>
        </van-dialog>
    </div>
</template>
<script>
    import VillagesTopNav from '../../components/VillagesTopNav.vue'
    import { Toast,Dialog } from 'vant';
    export default {
        data() {
            return {
                value: "",
                radio: '1',
                show: false
            }
        },
        methods: {
            payClick() {
		 let param = {
			  client_type : 'WAP',
			  trade_type : 'trade',
              payment_plugin_id : 'weixinPayPlugin',
              points : this.value
		  }
		 this.getRequest(`order/pay/appPayPoint`, param).then(res => {
            console.log(res,res.data,res.data.data);
                function onBridgeReady(){
                WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
                "appId":res.data.data.appId,     //公众号名称，由商户传入     
                "timeStamp":res.data.data.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":res.data.data.nonceStr, //随机串     
                "package":res.data.data.package,     
                "signType":"MD5",         //微信签名方式：     
                "paySign":res.data.data.paySign  //微信签名 
                },
                function(res){
                if(res.err_msg == "get_brand_wcpay_request:ok" ){
                    Toast.success('支付成功');
                    this.show = true;
                // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                }else{
                    Toast.fail('支付失败');
                }
            }); 
            }
            if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
            }else{
            onBridgeReady();
            }
     
		 });
		  // this.$router.push('./SuccessfulPayment')
	  }
          
        },
        components: {
            VillagesTopNav,
        },
    }
</script>
<style>
    .invest-currency .van-radio__icon--checked .van-icon {
        background: linear-gradient(-270deg, #FA4D1F, #CD1709);
        border: 0 solid transparent;
    }

    .invest-currency .van-cell__title span {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
    }
</style>
<style scoped>
    .cgdialog {
        width: 560px;
    }

    .chenggong {
        height: 270px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

    }

    .chenggong img {
        width: 78px;
        height: 78px;
        margin-bottom: 30px;
    }

    .pay-currency-btn {
        width: 426px;
        height: 94px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 36px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 32px;
        background: url('../../assets/img/icon/currencybtn.png');
        background-size: 100% 100%;
        position: fixed;
        bottom: 48px;
        left: 50%;
        transform: translateX(-50%);
    }

    .pay-left-icon {
        width: 42px;
        height: 37px;
        position: relative;
        margin-right: 20px;
        top: 3px;
    }

    .invest-currency {
        min-height: 100vh;
        background-color: #f5f5f5;
    }

    .pay-type {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(158, 158, 158, 1);
        line-height: 37px;
        margin: 70px 0 14px 33px;
    }

    .invest-input {
        width: 619px;
        height: 110px;
        background: rgba(245, 245, 245, 1);
        border-radius: 2px;
        margin: 0 auto;
        display: flex;
    }

    .invest-input .van-cell.van-field {
        background-color: transparent;
        line-height: 110px;
        padding: 0px;
        padding-right: 20px;
        display: flex;
        align-items: center;

    }

    .invest-input .van-cell.van-field input {
        font-size: 62px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: rgba(46, 46, 46, 1);
    }

    .invest-input .symbol {
        font-size: 72px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: rgba(46, 46, 46, 1);
        line-height: 100px;
        margin: 5px 20px;
    }

    .shouzhi-list-title {
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 42px;
        margin-top: 37px;
        margin-bottom: 25px;
        padding-left: 30px;
    }

    .currency-top-bk {
        width: 750px;
        background: linear-gradient(360deg, #F5F5F5 36%, rgba(206, 16, 3, 1) 100%);
        background-color: #FBFBFB;
        overflow: hidden;
    }

    .currency-top-bk>div {
        width: 750px;
        background: url('../../assets/img/icon/currencybk.png') no-repeat;
        background-size: 100%;
    }

    .currency-top-bk h2 {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        line-height: 50px;
    }

    .chong-zhi {
        width: 694px;
        height: 460px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.05);
        border-radius: 20px;
        margin: 30px auto 0px;
        overflow: hidden;
    }

    .invest-currency .currency-font {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 40px;
        text-align: center;
        margin: 90px auto 30px;
    }
</style>